export const UrlAgendaLoja = "AgendaLoja";
export const DataLabelAgendaAberta = "Agenda Aberta Início";
export const DataLabelAgendaFechada = "Agenda Aberta fim";
export const DataLabelBloqueioAberto = "Bloqueio Aberto";
export const DataLabelBloqueioFechado = "Bloqueio fim";
export const SwitchTodoDia = "Todos os dias? ";
export const SwitchBloqueio = "Bloquear agenda? ";
export const UrlBuscarPaginado = "Agenda/BuscarPaginado";
export const UrlAgenda = "Agenda";
export const TipoLoja = "1";
export const TipoColaborador = "2";
export const ModalTexto = "Deseja remover o item?";

export const propertyLabelsLoja: { [key: string]: { label: string; ordem?: number } } = {
    razaoSocial: { label: "Loja", ordem: 1 },
    agendaAbertaInicio: { label: "Agenda Aberta Início", ordem: 2 },
    agendaAbertaFim: { label: "Agenda Aberta Fim", ordem: 3 },
    diaInicioSemana: { label: "Dia Semana Início", ordem: 4 },
    diaSemanaFim: { label: "Dia Semana Fim", ordem: 5 },
};

export const propertyLabelsColaborador: { [key: string]: { label: string; ordem?: number } } = {
    nome: { label: "Nome", ordem: 1 },
    agendaAbertaInicio: { label: "Agenda Aberta Início", ordem: 2 },
    agendaAbertaFim: { label: "Agenda Aberta Fim", ordem: 3 },
    agendaBloqueadaInicio: { label: "Bloqueio Início", ordem: 4 },
    agendaBloqueadaFim: { label: "Bloqueio Fim", ordem: 5 },
    diaInicioSemana: { label: "Dia Semana Início", ordem: 6 },
    diaSemanaFim: { label: "Dia Semana Fim", ordem: 7 },
};
